<template>
  <div v-if="estaticos && estaticos.length" class="option-section">
    <div class="option-header">
      <span class="option-title">Incluye</span>
    </div>
    <div class="estaticos-list">
      <div
        v-for="(grupoEstatico, i) in estaticos"
        :key="`grupo_estatico_${i}`"
      >
        <div
          v-for="(estatico, k) in grupoEstatico.productos"
          :key="`estatico_${k}`"
          class="estatico-row"
        >
          <v-avatar v-if="!hasNoImage(estatico)" size="40" rounded class="mr-3">
            <v-img :src="estatico.detalle.srcImg" cover></v-img>
          </v-avatar>
          <div class="estatico-info">
            <div class="estatico-name">{{ estatico.nombre }}</div>
            <div class="estatico-qty">Cantidad: {{ estatico.CantMinima }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Estatico',
  props: {
    estaticos: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    hasNoImage (product) {
      return product && product.detalle && product.detalle.srcImg && product.detalle.srcImg.includes('noimage_Producto.png')
    }
  }
}
</script>
<style scoped>
.option-section {
  margin-top: 8px;
  background: #f7f7f7;
  border-radius: 12px;
  overflow: hidden;
  padding-bottom: 4px;
}
.option-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 0;
}
.option-title {
  font-weight: 700;
  font-size: 1.05rem;
}
.estaticos-list {
  padding: 8px 16px 12px;
}
.estatico-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.estatico-row:last-child {
  border-bottom: none;
}
.estatico-name {
  font-weight: 600;
  font-size: 0.95rem;
}
.estatico-qty {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.55);
}
</style>
